<template>
	<footer class="am-footer">
		<div class="am-footer__container">
			<div class="am-footer__social">
				

				<am-text class="am-footer__label" :dark="true" type="button">
			        <p class="address">
				        <b>CNPJ:</b> 09.602.095/0001-98<br><br>
				        <b>Endereço:</b> Av. Edson Ramalho, 910 (salas 101A e 101B)<br> Manaíra - 58.038-102  - João Pessoa/PB<br><br>
				        <b>Razão Social:</b> Invista Empreendimentos Imobiliários LTDA<br><br>
			        </p>
		        </am-text>
				<!-- <am-icon name="linkedin" :dark="true" size="sm" /> -->
			</div>

			<am-brand
				class="am-footer__brand"
				:dark="true"
				:typo="true"
			/>

			<a href="http://qualitare.com.br" class="am-footer__author" target="_blank" title="Qualitare">
				<img src="/images/qualitare.svg" alt="Qualitare">
			</a>
		</div>
	</footer>
</template>

<script>
import AMText from '@/components/atoms/AMText'
import AMIcon from '@/components/atoms/AMIcon'
import AMBrand from '@/components/atoms/AMBrand'

export default {
	components: {
		'am-text': AMText,
		'am-icon': AMIcon,
		'am-brand': AMBrand
	},
	methods:{
		onClick(provider){
			if (provider == 'facebook'){
				window.open("https://www.facebook.com/conddasamericas","_blank")
			} else if (provider == 'instagram') {
				window.open("https://www.instagram.com/condominiodasamericas/","_blank")
			}
		},
	}
}
</script>

<style lang="scss">
.am-footer{
	background: $c-brown;
	padding-top: 50%;
    padding-bottom: 100%;
	&__container{
		height: 100%;
		display: flex;
		align-items: center;
		flex-flow: column;
		justify-content: space-around;
		@include outer-container;
	}
	&__social{
		.am-icon{
			margin-right: 8px;
			cursor: pointer;
		}
	}
	&__label{
		font-size: 15px;
		margin-bottom: 8px;
	}
	&__brand{
	}
	&__author{
	}

	@include grid-media($smartphone-grid) {
		.am-footer{

			&__brand{
				order: 1;
			}
			&__social{
				text-align: center;
				order: 2;
			}
			&__author{
				order: 3;
			}
		}
	}

	@include grid-media($tablet-grid) {
		padding-top: 25%;
    	padding-bottom: 100%;
		.am-footer{
			&__brand{
				order: 1;
			}
			&__social{
				text-align: center;
				order: 2;
			}
			&__author{
				order: 3;
			}
		}
	}

	@include grid-media($desktop-grid) {
		padding-top: 0;
    	padding-bottom: 0;
		&__container{
			display: flex;
			height: 300px;
			align-items: center;
			flex-flow: row;
			justify-content: space-between;
		}
		&__brand{
			@include grid-column(4);
		}
		&__social{
			@include grid-column(4);
		}
		&__author{
			text-align: right;
			@include grid-column(4);
		}
	}
}
</style>
